export const CODE_PER = '51'
export const CODE_DNI = '01'
export const CODE_CE = '04'
export const CODE_RUC = '06'
export const CODE_PS = '07'
export const CODE_NAC = '11'
export const ERROR_CEL = 'El número de celular es incorrecto'
export const ERROR_CEL_PER = 'El número de celular debe tener 9 digitos'
export const ERROR_CEL_EXT = 'El número de celular debe tener máximo 13 digitos'
export const ERROR_DNI = 'El número de DNI es incorrecto'
export const ERROR_CE = 'El número de C.E es incorrecto'
export const ERROR_RUC = 'El número de RUC es incorrecto'
export const ERROR_PS = 'El número de P.S es incorrecto'
export const ERROR_NAC = 'El número de P.NAC es incorrecto'
export const URL_MICUENTA_DEPAS = process.env.REACT_APP_URL_MICUENTA_DEPAS ?? ''

export const WEBORIGEN_VIVIENDA = "VIVIENDA"

export const LOCALSTORAGE_WEBORIGEN_VIVIENDA = "weborigen"
export const LOCALSTORAGE_LOGIN_TYPE = "login"
export const LOCALSTORAGE_VERIFICATION = "verification"
export const LOCALSTORAGE_LOGIN_TYPE_ACCOUNT = "account"
export const LOCALSTORAGE_LOGIN_TYPE_LETTER = "letter"
export const LOCALSTORAGE_LOGIN_TYPE_CASH = "cash"
export const LOCALSTORAGE_CONFIG = "config";
export const LOCALSTORAGE_TIPO_DOCUMENTO_PAGO = "type";

export const LOCALSTORAGE_TOKEN = "token"
export const LOCALSTORAGE_REFRESH_TOKEN = "refreshToken"
export const LOCALSTORAGE_ACCESS_TOKEN_EXPIRES_AT = "accessTokenExpiresAtUtc"
export const LOCALSTORAGE_REFRESH_TOKEN_EXPIRES_AT = "refreshTokenExpiresAtUtc"
export const LOCALSTORAGE_SESSION_EXPIRES_AT = "sessionExpiresAtUtc"
export const LOCALSTORAGE_PIN_CHALLENGE = "pinChallenge"

export const PAGINA_LOGIN_MICUENTA = "miCuenta"

export const CRYPTOLOAD = "5A1DC225-9CC3-4B0F-AD9E-DDF486710CF8"

